import {RiskLimits} from "../RiskSummaryRecord";
import {RiskRowEntityType} from "../RiskRowEntityType";
import {Optional} from "../../../../js/util/Optional";
import {ObjectUtil} from "../../../../js/util/ObjectUtil";

export class RiskDashboardChangeModel {

    private constructor(private readonly changes = new Map<RiskRowEntityType, Map<number, RowChanges>>()) {

    }

    public get(type: RiskRowEntityType, id: number): RowChanges {
        return Optional.of(type)
                       .map((t) => this.changes.get(t))
                       .map((m) => m.get(id))
                       .map((c) => ObjectUtil.copy(c))
                       .orElseGet(() => this.empty());
    }

    private empty(): RowChanges {
        return EmptyChanges();
    }

    public set(type: RiskRowEntityType, id: number, changes: RowChanges): RiskDashboardChangeModel {
        const typeChanges = Optional.of(this.changes.get(type))
                                    .orElseGet(() => new Map());
        const entityChanges = Optional.of(typeChanges)
                                      .map((tc) => tc.get(id))
                                      .orElseGet(() => this.empty());
        const updated = ObjectUtil.merge({}, entityChanges, changes);

        const typeCopy = new Map(typeChanges.entries());
        typeCopy.set(id, updated);

        const stateCopy = new Map(this.changes.entries());
        stateCopy.set(type, typeCopy);

        return new RiskDashboardChangeModel(stateCopy);
    }

    public reset(type: RiskRowEntityType, id: number): RiskDashboardChangeModel {
        const typeChanges = Optional.of(this.changes.get(type))
                                    .orElseGet(() => new Map());
        const typeCopy = new Map(typeChanges.entries());
        typeCopy.set(id, EmptyChanges());
        const stateCopy = new Map(this.changes.entries());
        stateCopy.set(type, typeCopy);
        return new RiskDashboardChangeModel(stateCopy);
    }

    public static init(): RiskDashboardChangeModel {
        return new RiskDashboardChangeModel();
    }
}

export type RowChanges = Partial<RiskLimits>;

export function EmptyChanges(): RowChanges {
    return {};
}
